import axios from 'axios';
import { constants } from '@skunexus/utils';

const {
    CONFIG: { API_PATH },
} = constants;

export const rePushOrder = ({ id }) => axios.post(`${API_PATH}/purchase-order/${id}/repush`, {});

export const cancelOrder = ({ id, data }) => axios.post(`${API_PATH}/purchase-order/${id}/cancel`, data);

export const cancelItems = ({ id, data }) => axios.post(`${API_PATH}/purchase-order/${id}/cancel-items`, data);
